import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import axios from "axios";
import AdminAuthShell, { AuthField, AuthSubmit } from "@/components/AdminAuthShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  if (typeof window !== "undefined" && localStorage.getItem("admin_token")) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("admin_token", data.access_token);
      localStorage.setItem("admin_email", data.user?.email || email);
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Errore di autenticazione.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminAuthShell
      testId="admin-login-page"
      title="Studio Cecconato"
      intro="Accedi con la tua email e password per gestire le richieste di contatto."
      error={error}
      footer={
        <Link
          to="/admin/password-dimenticata"
          data-testid="admin-forgot-link"
          className="text-slate-600 hover:text-slate-900 underline underline-offset-4"
        >
          Password dimenticata?
        </Link>
      }
    >
      <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
        <AuthField
          label="Email"
          type="email"
          autoFocus
          required
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email-input"
        />
        <AuthField
          label="Password"
          type="password"
          required
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password-input"
        />
        <AuthSubmit
          loading={loading}
          loadingLabel="Accesso in corso..."
          data-testid="admin-login-submit"
        >
          Accedi
        </AuthSubmit>
      </form>
    </AdminAuthShell>
  );
}
